<template>
  <div class="content">
    <div class="cancel-schedule-content" v-r-loading="loading">
      <template v-if="errCode">
        <EmptyState emptyType="noNetwork" @tryAgain="cancelDuty" />
      </template>
      <template v-else>
        <CancelOrderContent>
          <template v-slot:left>
            <div class="img-content">
              <img :src="statusImg" v-img-error alt="" class="img" />
            </div>
            <div class="flow-title">{{ flowData.title }}</div>
            <div class="desc" v-if="isH5">{{ flowData.subTitle }}</div>
          </template>
          <template v-slot:right>
            <div class="right-cont">
              <p class="tit" v-if="!isH5">{{ $t('取消订单进度') }}</p>
              <CancelOrderSteps
                class="cancel-order-steps"
                :stepsList="flowData.flow"
                :title="isH5 ? '' : flowData.subTitle"
              >
              </CancelOrderSteps>
            </div>
          </template>
        </CancelOrderContent>
        <div class="button-content">
          <el-button class="btn" @click="goOrderDetail"
            >{{ $t('确认') }}
          </el-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import { get } from 'lodash-es';
import CancelOrderContent from '@/components/CancelOrderContent';
import CancelOrderSteps from '@/components/CancelOrderSteps';
import statusImg from '@/assets/images/order/cancel/merchat_handling.png';
import { mapState } from 'vuex';
import { ERROR_CODE, REFRESH_TIME } from '../const';
import EmptyState from '@/components/EmptyState';

export default {
  name: 'cancelOrderSchedule', // 取消进度
  components: {
    CancelOrderContent,
    CancelOrderSteps,
    EmptyState,
  },
  data() {
    return {
      // 进度信息
      flowData: {},
      loading: false,
      statusImg: statusImg,
      errCode: null,
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
  },
  methods: {
    // 获取取消进度信息
    async getCancelFlow() {
      try {
        this.loading = true;
        
        const orderId = get(this, '$route.query.orderId', null);
        if (!orderId) return;
        this.flowData = await api.getCancelFlow({ orderId });
        this.loading = false;
      } catch (error) {
        const errno = get(error, 'errno', null);
        // 关闭订单已完成页面
        if (+errno === ERROR_CODE.ORDER_STATUS_UPDATE) {
          this.goOrderList();
        } else if (+errno === ERROR_CODE.INFO_UPDATE) {
          setTimeout(() => {
            this.getCancelFlow();
          }, REFRESH_TIME);
        } else {
          this.errCode = errno;
          this.loading = false;
        }
      }
    },
    cancelOrderProgressTrack() {
      const orderId = get(this, '$route.query.orderId', '');
      const orderStatus = get(this, 'cancelData.order_status', '');
      this.$trackEvent({
        eventId: 'sailing_c_x_cancelorder_progress_sw',
        eventLabel: '取消订单进度页面曝光',
        attrs: {
          order_id: orderId,
          order_status: orderStatus,
        },
      });
    },
    // 跳转订单详情页面
    goOrderDetail() {
      const orderId = get(this, '$route.query.orderId', null);
      if (!orderId) return;
      this.$router.push({
        path: '/orderDetail/',
        query: {
          orderId,
        },
      });
    },
    goOrderList() {
      this.$router.push({
        path: '/order/',
      });
    },
  },
  created() {
    this.getCancelFlow();
    this.cancelOrderProgressTrack();
  },
};
</script>
<style lang="scss">
.cancel-schedule-content {
  .cancel-order-content .right {
    padding: 24px 24px 0;
  }

  .cancel-order-content {
    display: flex;
    position: relative;
    height: 100%;

    .left {
      width: 470px;
      height: 100%;
      padding-bottom: 80px;
      overflow-y: auto;
    }

    .right {
      flex: 1;
      overflow-y: auto;
      text-align: left;
    }
  }
}
// 移动端适配
@media screen and (max-width: 768px) {
  .cancel-schedule-content {
    border-radius: 0;
    .cancel-order-content {
      display: block;
      .left {
        width: auto;
        min-height: 0;
      }
      .right {
        padding: 0;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import '../../control_global.scss';
.content {
  height: calc(100vh - #{$pc_cont_height});
  position: relative;
  max-width: 940px;
  margin: 0 auto 80px;
  border-radius: 8px;
  background: #fff;
}
.button-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: right;
  height: 80px;
  padding-right: 20px;
  background: #ffffff;
  .btn {
    margin: 20px 0 20px 20px;
    min-width: $pc_button_min_width;
  }
}
.img-content {
  width: 250px;
  height: auto;
  margin: 120px auto 0;
  .img {
    width: 100%;
    height: 100%;
  }
}
.cancel-schedule-content {
  height: 100%;
  overflow-y: auto;
  border-radius: 8px;
  .flow-title {
    margin: 24px 75px;
    text-align: center;
    font-family: 'Aspira Medium';
    font-size: 24px;
    line-height: 28px;
    color: #000000;
  }
  .tit {
    margin-bottom: 20px;
    font-family: 'Aspira Medium';
    font-size: 24px;
    line-height: 28px;
    color: #000000;
  }
  .right-cont {
    margin-top: 16px;
    background: #fff;
    padding-bottom: 80px;
  }
  .footer-content {
    border-radius: 0 0 8px 8px;
    background: #fff;
    min-height: 80px;
    margin: 0 auto;
    max-width: 940px;
    text-align: right;
    .btn {
      margin: 20px 24px 20px 0;
      min-width: $pc_button_min_width;
    }
  }
}
// 移动端适配
@media screen and (max-width: 768px) {
  .header-box {
    position: sticky;
    top: 0;
    z-index: 9;
  }
  .cate-header-wrapper {
    position: relative;
  }
  .content {
    height: auto;
    margin: 0 0;
    background: #f5f5f7;
    padding: 0 rem(24);
    border-radius: 0;
  }
  .cancel-schedule-content {
    height: auto;
    min-height: calc(100vh - #{$h5_btn_height});
    margin-bottom: 0;
    padding: 0 0 $h5_btn_height;
    border-radius: 0;
    .cancel-order-content {
      padding-top: rem(96);
      height: auto;
    }
    .img-content {
      background: #f5f5f7;
      width: 100%;
      height: 100%;
      margin-left: 0;
      padding: 0 rem(160);
      margin: 0 auto;
      img {
        width: 100%;
        height: auto;
      }
    }
    .right-cont {
      min-height: 0;
      height: auto;
      padding: 0 rem(16);
      border-radius: rem(12);
    }
    .flow-title {
      margin: rem(40) rem(64) rem(24);
      text-align: center;
      font-family: 'Aspira Medium';
      font-size: rem(44);
      line-height: rem(52);
      color: #000000;
    }
    .desc {
      font-family: 'Aspira Light';
      font-size: rem(28);
      line-height: rem(36);
      color: #999999;
      text-align: center;
    }
    .button-content {
      position: fixed;
      bottom: 0;
      padding: rem(38) rem(24);
      background: transparent;
      .btn {
        display: block;
        margin: 0 0;
        width: 100%;
      }
    }
  }
}
</style>
